"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageNumberKeyboard = exports.PERIOD_KEY_ID = exports.BACK_KEY_ID = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
const types_1 = require("../../gameplay/types");
const icons_material_1 = require("@mui/icons-material");
exports.BACK_KEY_ID = 'Back';
exports.PERIOD_KEY_ID = '.';
function LanguageNumberKeyboard({ gameplayStyle, ...rest }) {
    const keys = [
        '7',
        '8',
        '9',
        '4',
        '5',
        '6',
        '1',
        '2',
        '3',
        '0',
        exports.PERIOD_KEY_ID,
        exports.BACK_KEY_ID,
    ];
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
        react_1.default.createElement("div", { className: "flex justify-center" },
            react_1.default.createElement("div", { className: "grid grid-cols-3 gap-[24px]" }, keys.map(key => {
                return (react_1.default.createElement(material_1.Button, { id: key, key: key, size: "large", variant: "outlined", sx: {
                        aspectRatio: 1,
                        width: '69px',
                        color: `${getKeyColor(gameplayStyle)}`,
                        borderColor: `${getKeyColor(gameplayStyle)}`,
                        borderRadius: '9999px',
                        fontFamily: 'Effra',
                        fontSize: '24px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '26px',
                        letterSpacing: '0.46px',
                    }, ...rest }, key === exports.BACK_KEY_ID ? react_1.default.createElement(icons_material_1.Backspace, null) : key));
            })))));
}
exports.LanguageNumberKeyboard = LanguageNumberKeyboard;
function getKeyColor(gameplayStyle) {
    const theme = (0, utils_1.getTheme)(gameplayStyle);
    switch (gameplayStyle) {
        case types_1.GameplayStyle.PopStudy:
            return theme.palette.primary.main;
        case types_1.GameplayStyle.PopQuiz:
        case types_1.GameplayStyle.PopQuizHost:
            return theme.palette.primary.contrastText;
    }
}
